import useTranslation from 'next-translate/useTranslation'
import {
  Layout,
  StickyContentSection,
  ContentNotFound,
} from '../components/common'
import { useRouter } from 'next/router'
import { PageService } from '../services'
import { ISSRPageData } from '@interfaces'

const PrivacyPolicyScreen = ({
  pageData,
  global: { navigation },
}: ISSRPageData) => {
  const { t } = useTranslation()
  const { asPath } = useRouter()

  if (pageData.error) {
    return (
      <Layout
        title={t('common:ssmPageTitle')}
        navigation={navigation}
        path={asPath}
      >
        <ContentNotFound infoType="serverSideError" />
      </Layout>
    )
  }

  return (
    <Layout
      title={pageData?.data?.title || t('legal:privacyPolicy.pageTitle')}
      navigation={navigation}
      path={asPath}
    >
      <StickyContentSection
        title={pageData?.data?.title || t('legal:privacyPolicy.pageTitle')}
        descriptions={pageData?.data?.htmlContent}
      />
    </Layout>
  )
}

export default PrivacyPolicyScreen

export async function getStaticProps({ locale }) {
  const pageData = await PageService.getBasicPage(locale, 'privacyPolicy')

  return {
    props: { pageData },
  }
}
